import { BaseCard } from '@/components/ui/base-card'
import { ExcludeCellIcon } from '@/icons/ExcludeCellIcon'
import { IncludeCellIcon } from '@/icons/IncludeCellIcon'
import { handleManualFilterReset } from '@/redux/store/slices/grid/gridSlice'
import { toggleTool } from '@/redux/store/slices/map/mapSlice'
import { useAppDispatch, useAppSelector } from '@redux/hooks/useAppState'
import { EXCLUSION_TOOL, INCLUSION_TOOL } from 'honeygrid-types'
import { Trash2 } from 'lucide-react'

import type { MapTool } from 'honeygrid-types'
import type { FC } from 'react'

export interface ManualFilterCardProps {
	type: NonNullable<MapTool>
}

export const ManualFilterCard: FC<ManualFilterCardProps> = ({ type }) => {
	const dispatch = useAppDispatch()
	const enabledTool = useAppSelector((state) => state.map.selectedTool)

	let title = ''
	let IconComponent = <></>
	if (type === INCLUSION_TOOL) {
		title = 'Manual inclusion'
		IconComponent = <IncludeCellIcon className="h-4 w-4" />
	} else if (type === EXCLUSION_TOOL) {
		title = 'Manual exclusion'
		IconComponent = <ExcludeCellIcon className="h-4 w-4" />
	}

	const onCardClick = () => {
		dispatch(toggleTool(type))
	}

	const onRemove = (e: React.MouseEvent) => {
		e.stopPropagation()
		dispatch(handleManualFilterReset({ selectedTool: type }))
		dispatch(toggleTool(null))
	}

	return (
		<div className="w-full">
			<BaseCard
				title={title || 'Manual filter'}
				titleIcon={IconComponent}
				isSelected={enabledTool === type}
				isClickable={true}
				onClick={onCardClick}
				singleActionIcon={<Trash2 className="h-4 w-4" />}
				singleActionOnClick={() => onRemove({} as React.MouseEvent)}
				singleActionVariant="destructive"
				showActionsOnHover={true}
			>
			</BaseCard>
		</div>
	)
}
